module.exports = __webpack_public_path__ + "0750a92f781b909530a6e6ecc9aa9b96.png";